<template>
  <Collapse
    :id="`comment-history-${submission.id}`"
    class="tenant-submission-comment-history"
    :expand="false"
    :withBorder="false"
  >
    <div
      slot="title"
      class="comment-title"
    >{{ $t('tenantProjects.reviewHistory') }}</div>
    <div
      slot="content"
      class="comment-contents"
    >
      <div class="desgin-comment-content">
        <div class="title">{{ $t('tenantProjects.submission.cp') }}</div>
        <p class="design-comment-text">
          <pre>{{ designComment.description || '--' }}</pre>
        </p>
        <div class="design-comment-history">
          <div
            v-for="rec in designCommentHistory"
            :key="rec.id"
            class="clearfix history-item"
          >
            <div class="update-history__text">{{ rec.user.displayName }}</div>
            <div class="update-history__text">{{ dateUtil.format(rec.updatedAt, 'DD MMM YY HH:mm') }}</div>
          </div>
        </div>
      </div>
      <div class="tech-comment-content">
        <div class="title">{{ $t('tenantProjects.submission.pm') }}</div>
        <div class="tech-comment-history">
          <div
            v-for="rec in techCommentHistory"
            :key="rec.id"
            class="clearfix history-item"
          >
            <div class="update-history__text">{{ rec.user.displayName }}</div>
            <div class="update-history__text">{{ dateUtil.format(rec.updatedAt, 'DD MMM YY HH:mm') }}</div>
          </div>
        </div>
      </div>
    </div>
  </Collapse>
</template>

<script>
import Collapse from '@/controls/Collapse'
import dateUtil from '@/utils/dateUtil'
import { CommentTypes, CommentObject, CommentActionTypes } from './consts'

export default {
  name: 'CommentHistory',
  components: {
    Collapse,
  },
  props: {
    submission: {
      type: Object,
      default () { return {} },
    },
  },
  data () {
    return {
      dateUtil,
    }
  },

  computed: {
    designComment () {
      return deep(this.submission, 'designComment') || {}
    },
    techComment () {
      return deep(this.submission, 'techComment') || {}
    },
    designCommentHistory () {
      return (deep(this.submission, 'actionHistory') || [])
        .filter(rec => rec.actionType === CommentActionTypes.UPDATE &&
          rec.commentObject === CommentObject.COMMENT &&
          rec.commentTypes.includes(CommentTypes.DESIGN) && !rec.isNewRec)
    },
    techCommentHistory () {
      return (deep(this.submission, 'actionHistory') || [])
        .filter(rec => (rec.actionType === CommentActionTypes.REVIEW &&
          rec.commentTypes.includes(CommentTypes.TECH) && !rec.isNewRec) || (rec.actionType === CommentActionTypes.SEND))
    },
  },
}
</script>

<style lang="scss" scoped>
.tenant-submission-comment-history {
  ::v-deep .title-container {
    border-bottom: 1px solid #e0e0e0;
  }

  .comment-title, .title {
    font-weight: bold;
  }

  .comment-contents {
    margin-top: 10px;
  }

  .desgin-comment-content {
    margin-bottom: 16px;
  }

  .design-comment-history, .tech-comment-history {
    width: 350px;
    .history-item {
      display: flex;
    }
  }

  .update-history__text {
    flex: 1;
    color: #878787;
    font-size: 11px;
    padding-left: 0 10px;
    font-style: italic;
    line-height: 20px;
    p, div {
      margin-bottom: 0;
      text-align: right;
    }
  }
}
</style>
